var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_3578_1558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.125471 27.6839V32.9999H23.7453V26.7223L0.125471 27.6839ZM24.8744 1.33514C24.7281 11.6269 25.1839 22.7081 25.0375 32.9957C27.6931 32.9957 30.3445 32.9957 33 32.9957C33 24.5641 33 16.1324 33 7.70084C31.1098 5.13104 28.0276 2.44788 24.8744 1.33514ZM0.125471 7.0038C0.184019 8.89335 -0.0459897 10.8459 0.012558 12.7354C5.7126 8.32649 13.0812 5.47956 23.7453 7.0038C23.7453 4.96308 23.7453 2.93076 23.7453 0.898444C16.8032 -1.0499 9.20037 -0.1849 0.125471 7.0038ZM0.125471 14.0791C0.125471 15.8889 0.125471 17.6903 0.125471 19.4916C6.67863 15.658 14.5449 14.4234 23.7453 15.8217C23.7453 13.7012 23.7453 11.5765 23.7453 9.45602C16.2135 7.92758 8.35561 9.33425 0.125471 14.0791ZM0.125471 20.6674C0.125471 22.5611 0.125471 24.4507 0.125471 26.336C7.79522 24.3373 15.6197 24.0098 23.7453 24.3373C23.7453 22.4855 23.7453 19.8108 23.7453 17.9632C15.2141 17.1738 7.38957 18.1984 0.125471 20.6674Z",
    fill: "#0885C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3578_1558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.f708322c52e8e8ae81f161500af02753.svg";
export { ForwardRef as ReactComponent };